import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useAdminSupport } from "@/hooks/useAdminSupport";
import { Loader2 } from "lucide-react";

export function SorvaineAdminGuard({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const { isAdminArea, isLoading } = useAdminSupport();

  if (loading || isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) return <Navigate to="/auth" replace />;
  if (!isAdminArea) return <Navigate to="/dashboard" replace />;

  return <>{children}</>;
}
